import React from 'react';
import { CSSObject } from '@emotion/react';
import useBreakpoints from '@hooks/useBreakpoints';
import { useTranslate } from 'nucleus-text';
import Button from '@cvent/carina/components/Button';
import { FOCUS_OUTLINE_IN_FIREFOX } from '@tools/globalStylesConstants';

interface LandingPageCallToActionProps {
  onLogin: React.MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>;
  size?: 's' | 'm' | 'l';
}

const useStyles = (): Record<string, CSSObject> => {
  const { mediaIsMobile, mediaIsS } = useBreakpoints();

  return {
    buttonContainer: {
      display: 'flex',
      flexDirection: 'row',
      'button:first-of-type': {
        marginRight: 20,
        [mediaIsMobile]: {
          marginRight: 16
        },
        [mediaIsS]: {
          marginRight: 16
        }
      }
    }
  };
};

function LandingPageCallToAction({ onLogin, size = 'l' }: LandingPageCallToActionProps): JSX.Element {
  const { buttonContainer } = useStyles();
  const { translate } = useTranslate();

  return (
    <div css={buttonContainer}>
      <Button
        text={translate('Universal-Login')}
        testID="landing-page-login-button"
        appearance="lined"
        onClick={onLogin}
        size={size}
        css={{ ...FOCUS_OUTLINE_IN_FIREFOX }}
      />
    </div>
  );
}

export default LandingPageCallToAction;
